var _a;
import * as React from 'react';
import Cookies from 'universal-cookie';
export var Provider = (_a = React.createContext(new Cookies()), _a.Provider), Consumer = _a.Consumer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-cookie/es6/CookiesContext.js
// module id = 469
// module chunks = 0